import React from 'react';
import MatchPercentageCircularBar from 'src/components/university/MathPercentageCirularBar';

const CandidateScore = ({ score }: { score: number }) => {
	return (
		<div className="w-[150px] m-auto">
			<MatchPercentageCircularBar value={Math.round(score || 0)} />
		</div>
	);
};

export default CandidateScore;
